import { useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { readSaveError } from "@/base/wizard/saveError";
import {
  addQuoteNote,
  noteError,
  type QuoteNote,
} from "@/lib/submissions/quoteConditions";

// One note on a quote (PMS-S749, BRK-S362), checked before it's sent: a blank
// or over-long note is refused here, and a refusal from PMS comes back in its
// words. The note is the caller's once PMS answers with it, never before (NN
// #7). The quote's Notes and "Ask Signal to cancel" (BRK-S373) both send one.

export function useSendQuoteNote(submissionId: string, quoteId: string) {
  const { authedRequest } = useAuth();
  const [problem, setProblem] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  /** The note PMS keeps, or null when it was refused (`problem` says why). */
  async function send(body: string): Promise<QuoteNote | null> {
    const refused = noteError(body);
    setProblem(refused);
    if (refused) return null;
    setSaving(true);
    try {
      return await addQuoteNote(authedRequest, submissionId, quoteId, body);
    } catch (err) {
      const refusal = readSaveError(err);
      setProblem(
        refusal.kind === "fields"
          ? (refusal.byField.body ?? refusal.summary)
          : refusal.message,
      );
      return null;
    } finally {
      setSaving(false);
    }
  }

  return { send, saving, problem };
}
